// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "*[data-v-86673952]{will-change:auto;transform:translateZ(0);backface-visibility:hidden;perspective:1000px}.expand-enter-active[data-v-86673952],.expand-leave-active[data-v-86673952]{transition:height 1s ease-in-out;overflow:hidden}.expand-enter[data-v-86673952],.expand-leave-to[data-v-86673952]{height:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
